module.exports = __webpack_public_path__ + "img/register.91b244cf.png";